/** Application configuration. */
export const APP_CONFIG = {
	isProduction: process.env.NX_IS_PRODUCTION,
} as const;
